import { DEFAULT_LANG } from '../../lib/locale.js'
import en from './en.js'
import de from './de.js'
import es from './es.js'
import fr from './fr.js'
import it from './it.js'
import pl from './pl.js'
import pt from './pt.js'

const TRANSLATIONS = { en, de, es, fr, it, pl, pt }

// Language-independent post metadata. Titles and excerpts live in the
// per-language files above, keyed by slug.
const POSTS = [
    { slug: 'multiple-languages', date: '2026-08-17', author: 'Stephen', version: '2.3' },
    { slug: 'micro-breaks', date: '2026-08-14', author: 'Stephen', version: '2.2' },
    { slug: 'dynamic-hold-system', date: '2026-03-01', author: 'Stephen', version: '2.1' },
    { slug: 'science-of-sitting', date: '2026-02-19', author: 'Stephen' },
    { slug: 'benefits-of-moving', date: '2026-02-10', author: 'Stephen' },
    { slug: 'keybreak-launch', date: '2026-02-01', author: 'Stephen', version: '2.0' },
]

const localize = (post, lang) => ({
    ...post,
    ...(TRANSLATIONS[lang]?.[post.slug] || TRANSLATIONS[DEFAULT_LANG][post.slug]),
})

export const getPosts = (lang = DEFAULT_LANG) => POSTS.map((post) => localize(post, lang))

export const getPostMeta = (lang, slug) => getPosts(lang).find((p) => p.slug === slug)
